import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../../assets/css/custom-toast.css';
import '../../../assets/css/meucorreios/dialog.css';
import '../../../assets/css/meucorreios/icones-correios.css';
import CheckboxGroup from '../../../components/form/CheckboxGroup';
import Input from '../../../components/form/Input';
import InputCadastro from '../../../components/form/InputCadastro';
import InputCpf from '../../../components/form/InputCpf';
import InputNomeCompleto from '../../../components/form/InputNomeCompleto';
import InputToken from '../../../components/form/InputToken';
import SelectGenero from '../../../components/form/SelectGenero';
import useFetch from '../../../components/hooks/useFetch';
import { abreAlertaDialog } from '../../../components/modal/AlertaDialog';
import Tabela from '../../../components/tabela/Tabela';
import { getIPAddress } from '../../../components/utils/GetIPAddress';
import {
  ALTERAR_MEUCORREIOS,
  ENVIAR_TOKEN,
  NECESSIDADES_ESPECIAIS,
  VALIDAR_E_ENVIAR_TOKEN,
} from '../../../services/meuCorreios';
import { createFormSchemas } from './FormSchema';

function FormAlterarDadosEstrangeiro() {
  const { t } = useTranslation();
  const { formSchemaAlteraDadosEstrangeiro } = createFormSchemas(t);
  const methods = useForm({
    resolver: yupResolver(formSchemaAlteraDadosEstrangeiro),
  });
  const [base64String, setBase64String] = useState('');
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };
  const [ipAddress, setIpAddress] = useState('');
  const location = useLocation();
  const dados = location.state;
  const navigate = useNavigate();
  const [desabilitarCampoMae, setDesabilitarCampoMae] = useState(true);
  const [podeAlterar, setPodeAlterar] = useState(true);
  const { request: requestRFB, data: dadosRFB } = useFetch();
  const [modalAbertoToken, setModalAbertoToken] = useState(false);
  const [sexo, setSexo] = useState(dados?.usuarioExternoPF.sexo);
  const sexoBanco = dados?.usuarioExternoPF.sexo;
  const { request } = useFetch();
  const [file, setFile] = useState(null);
  //const { request: requestNecessidades, data: listaNecessidades } = useFetch();
  const listaNecessidades = [
    { id: 1, descricao: 'Física' },
    { id: 2, descricao: 'Visual' },
    { id: 3, descricao: 'Intelectual' },
    { id: 4, descricao: 'Auditiva' },
    { id: 5, descricao: 'Psicossocial' },
    { id: 6, descricao: 'Múltipla' },
    { id: 7, descricao: 'Outras' },
  ];
  const {
    request: requestNecessidadesSelecionadas,
    data: listaNecessidadesSelecionadas,
  } = useFetch();

  useEffect(() => {
    if (dados) {
      //requestNecessidades(LISTAR_NECESSIDADES_ESPECIAIS());
      requestNecessidadesSelecionadas(NECESSIDADES_ESPECIAIS(dados.idCorreios));
    }
  }, [dados]);

  const [isCheckedNomeMaeDesconhecido, setIsCheckedNomeMaeDesconhecido] =
    useState(false);
  const [isCheckedInformarCPF, setIsCheckedInformarCPF] = useState(false);
  const handleNomeMaeDesconhecido = () => {
    setIsCheckedNomeMaeDesconhecido(!isCheckedNomeMaeDesconhecido);
  };
  const handleInformarCPF = () => {
    setIsCheckedInformarCPF(!isCheckedInformarCPF);
  };
  const openModalToken = () => {
    setModalAbertoToken(true);
  };
  const [nome, setNome] = useState();
  const [dataNascimento, setDataNascimento] = useState();
  const [imagem, setImagem] = useState();
  const [meioEnvio, setMeioEnvio] = useState('E');
  const [CPF, setCPF] = useState();
  const [necessidadesSelecionadas, setNecessidadesSelecionadas] = useState();
  const { request: requestMeuCorreios, data: dadosCPF } = useFetch();
  var cpfEnviar;

  const handleMeioEnvio = (event) => {
    setMeioEnvio(event.target.value);
  };
  const tableMetadata = [
    { key: 'name', value: 'Nome do arquivo' },
    { key: 'size', value: 'Tamanho do arquivo' },
  ];
  useEffect(() => {
    if (!isCheckedNomeMaeDesconhecido) {
      setDesabilitarCampoMae(false);
    } else {
      const form = document.getElementById('formAlterarDados');
      const nomeMaeInput = form.querySelector('#nomeDaMae');
      nomeMaeInput.value = '';
      setDesabilitarCampoMae(true);
    }
  }, [isCheckedNomeMaeDesconhecido]);
  useEffect(() => {
    if (!isCheckedInformarCPF) {
      methods.setValue('cpf', '');
    }
  }, [isCheckedInformarCPF]);
  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
      setPodeAlterar(true);
    };
    fetchIPAddress();
    if (dados.usuarioExternoPF.cpf) {
      setCPF(dados.usuarioExternoPF.cpf);
    }
  }, []);
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
      convertToBase64(file);
    }
  };
  const convertToBase64 = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setBase64String(reader.result.split(',')[1]);
    };
    reader.onerror = (error) => {
      abreAlertaDialog('Erro na conversão da imagem: ' + error);
    };
  };
  var nomeDaMae;
  const handleSubmit = async (data) => {
    const dataDate = new Date(data.dataNascimento);
    const dataFormatada = dataDate.toISOString().split('T')[0];
    const idsDosObjetos = listaNecessidadesSelecionadas.map((obj) =>
      String(obj.id),
    );
    if (
      isCheckedInformarCPF ||
      data.file.length != 0 ||
      dados.nome != data.nome ||
      dados.usuarioExternoPF.sexo != data.genero ||
      dataFormatada != dados.usuarioExternoPF.dataNascimento ||
      !(
        data.necessidadesEspeciais.length === idsDosObjetos.length &&
        data.necessidadesEspeciais.every((id) => idsDosObjetos.includes(id))
      ) ||
      (data.file && data.file.length === 1)
    ) {
      setNome(data.nome);
      setDataNascimento(data.dataNascimento);
      setImagem(data.file);
      setNecessidadesSelecionadas(data.necessidadesEspeciais);
      if (isCheckedInformarCPF) {
        if (data.nomeDaMae) {
          nomeDaMae = data.nomeDaMae;
        } else {
          if (isCheckedNomeMaeDesconhecido) {
            nomeDaMae = 'MAE DESCONHECIDA';
          }
        }
      }
      if (data.cpf) {
        cpfEnviar = data.cpf.replace(/[.-]/g, '');
      }
      const dadosEnviar = {
        nome: data.nome.trim().toUpperCase(),
        tipoUsuario: 'PF',
        nomeMae: nomeDaMae,
        dataNascimento: data.dataNascimento,
        cpf: cpfEnviar,
        idCorreios: dados.idCorreios,
        tipoEstrangeiro: dados.usuarioExternoPF.tipoEstrangeiro,
        token: {
          meioEnvio: meioEnvio,
          funcionalidade: 'ALTERAR_DADOS',
          //email: dados.email,
        },
      };
      const { response } = await request(
        VALIDAR_E_ENVIAR_TOKEN(dadosEnviar, ipAddress),
      );
      if (response.ok) {
        if (meioEnvio == 'E') {
          abreAlertaDialog(t('principal.messages.success.token_sent_email'));
        } else {
          abreAlertaDialog(t('principal.messages.success.token_sent_mobile'));
        }
        openModalToken();
      }
    } else {
      abreAlertaDialog(t('principal.messages.success.data_not_changed'));
    }
  };
  const alterar = async () => {
    const token1 =
      document.getElementById('confirmarSenha1').value +
      document.getElementById('confirmarSenha2').value +
      document.getElementById('confirmarSenha3').value +
      document.getElementById('confirmarSenha4').value +
      document.getElementById('confirmarSenha5').value +
      document.getElementById('confirmarSenha6').value;
    if (token1.length < 6) {
      abreAlertaDialog(
        t('principal.messages.validation.token_digits_required'),
      );
    } else {
      let imagem = base64String;
      if (imagem === '') {
        imagem = dados.usuarioExternoPF.imagem;
      }
      const dadosCompletos = {
        cie: dados.usuarioExternoPF.cie,
        idCorreios: dados.idCorreios,
        nome: nome.trim().toUpperCase(),
        cpf: cpfEnviar,
        dataNascimento: dataNascimento,
        sexo: sexo,
        imagem: imagem,
        tipoEstrangeiro: dados.usuarioExternoPF.tipoEstrangeiro,
        token: token1,
        necessidadesEspeciais: necessidadesSelecionadas,
      };
      const { response } = await request(
        ALTERAR_MEUCORREIOS(dadosCompletos, ipAddress),
      );
      if (response.ok) {
        abreAlertaDialog(t('principal.edit_data.messages.updated_success'));
        setModalAbertoToken(false);
        navigate('/principal');
      }
    }
  };
  const fecharToken = (ev) => {
    ev.preventDefault();
    setModalAbertoToken(false);
  };
  const fechar = (ev) => {
    ev.preventDefault();
    setModalAbertoToken(false);
    navigate('/principal');
  };
  const handleReset = () => {
    const form = document.getElementById('formAlterarDados');
    const campos = form.querySelectorAll('input');
    campos.forEach((campo) => {
      campo.value = '';
    });
  };
  const reenviaToken = async () => {
    const token = {
      meioEnvio: meioEnvio,
      funcionalidade: 'ALTERAR_DADOS',
      //email: dados.email,
    };
    const { response } = await request(ENVIAR_TOKEN(dados.idCorreios, token));
    if (response.ok) {
      if (meioEnvio == 'E') {
        abreAlertaDialog(t('principal.messages.success.token_sent_email'));
      } else {
        abreAlertaDialog(t('principal.messages.success.token_sent_mobile'));
      }
      openModalToken();
    }
  };
  return (
    <>
      {!modalAbertoToken ? (
        <div className="conteudo alterar-dados">
          <div
            id="cadastro-pf"
            className="cadastro-dados card bg-superficie elev1"
          >
            <form
              id="formAlterarDados"
              onSubmit={methods.handleSubmit(handleSubmit)}
            >
              <div className="dialog-main">
                <p className="subtitulo-p">
                  {t('principal.edit_data.profile_image')}
                </p>
                <div className="campo-perfil">
                  <img
                    id="input-img-perfil"
                    alt={t('principal.edit_data.profile_image')}
                    src="/images/avatar-placeholder.svg"
                    width="100"
                    height="100"
                  />

                  <div className="inputfile-container">
                    <Input type="hidden" name="MAX_FILE_SIZE" value="1000" />
                    <Input
                      type="file"
                      name="file"
                      id="file"
                      className="inputfile esconder-visualmente"
                      accept="image/*"
                      onChange={handleFileChange}
                      {...formMethods}
                    />

                    <div className="legenda">
                      {t('principal.edit_data.image_requirements')}
                    </div>

                    <label htmlFor="file" className="inputfile-label">
                      {t('principal.edit_data.include_image')}
                    </label>
                  </div>
                </div>
                {file && <Tabela headers={tableMetadata} dados={[file]} />}
                <div className="campo-txt">
                  <label className="subtitulo-p" htmlFor="input-nome">
                    {t('cadastro.forms.labels.full_name')}
                  </label>

                  <div className="campos">
                    <InputNomeCompleto
                      type="text"
                      id="nome"
                      name="nome"
                      placeholder=""
                      maxLength="150"
                      defaultValue={dados?.nome}
                      {...formMethods}
                    />
                  </div>
                  <div className="mensagem legenda"></div>
                </div>
                {dados?.usuarioExternoPF.cpf ? (
                  <div className="campo-txt">
                    <label className="subtitulo-p" htmlFor="input-cpf">
                      {t('cadastro.forms.labels.cpf')}
                    </label>

                    <Input
                      type="text"
                      //id="cpf"
                      //name="cpf"
                      disabled
                      defaultValue={dados?.usuarioExternoPF.cpfFormatado}
                      // {...formMethods}
                    />
                    <Input
                      type="hidden"
                      id="cpf"
                      name="cpf"
                      defaultValue={dados?.usuarioExternoPF.cpfFormatado}
                      {...formMethods}
                    />
                    <div className="mensagem legenda"></div>
                  </div>
                ) : (
                  <>
                    <label className="input-checkbox">
                      <Input
                        type="checkbox"
                        id="informarCPF"
                        name="informarCPF"
                        onClick={handleInformarCPF}
                        checked={isCheckedInformarCPF}
                        {...formMethods}
                      />
                      <div className="subtitulo-p">
                        {t('principal.edit_data.include_cpf_check')}
                      </div>
                    </label>

                    {isCheckedInformarCPF && (
                      <>
                        <InputCpf
                          label={t('cadastro.forms.labels.cpf')}
                          type="text"
                          id="cpf"
                          name="cpf"
                          // onBlur={handleCPF}
                          {...formMethods}
                        />
                        <InputNomeCompleto
                          type="text"
                          id="nomeDaMae"
                          name="nomeDaMae"
                          label={t('cadastro.forms.labels.mothers_name')}
                          maxLength="150"
                          placeholder=""
                          {...formMethods}
                          disabled={desabilitarCampoMae}
                        />
                        <label className="input-checkbox">
                          <Input
                            type="checkbox"
                            id="maeDesconhecida"
                            name="maeDesconhecida"
                            onClick={handleNomeMaeDesconhecido}
                            checked={isCheckedNomeMaeDesconhecido}
                            //disabled={!podeAlterar}
                            {...formMethods}
                          />
                          <div className="subtitulos-p">
                            {t('cadastro.forms.labels.unknown_mother_check')}
                          </div>
                        </label>
                      </>
                    )}
                  </>
                )}
                <div className="selecionar">
                  <div className="select-container">
                    <SelectGenero
                      id="genero"
                      name="genero"
                      label={t('cadastro.forms.labels.gender')}
                      value={sexoBanco}
                      onChange={(e) => setSexo(e.target.value)}
                      {...formMethods}
                    />
                    <div className="mensagem legenda"></div>
                  </div>
                </div>
                {!dados?.usuarioExternoPF.cpf && (
                  <div className="campo-txt">
                    <label className="subtitulo-p" htmlFor="input-data">
                      {t('cadastro.forms.labels.birth_date')}
                    </label>
                    <InputCadastro
                      className="input-data"
                      type="date"
                      id="dataNascimento"
                      name="dataNascimento"
                      defaultValue={dados?.usuarioExternoPF.dataNascimento}
                      {...formMethods}
                    />
                  </div>
                )}

                <div className="campos">
                  <div className="controle">
                    {listaNecessidades ? (
                      <CheckboxGroup
                        //className="checks"
                        name="necessidadesEspeciais"
                        options={[
                          ...listaNecessidades.map((item) => ({
                            id: item.id,
                            value: item.id,
                            label: item.descricao,
                            checked: listaNecessidadesSelecionadas?.some(
                              (i) => i.id == item.id,
                            ),
                          })),
                        ]}
                        label={t('cadastro.forms.labels.special_needs')}
                        {...formMethods}
                      ></CheckboxGroup>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>

                {dados?.ddiMovel === '55' ? (
                  <div className="receber-token radio-container">
                    <p className="">
                      {t('cadastro.messages.info.token_registration_method')}
                    </p>

                    <label className="radio">
                      <Input
                        type="radio"
                        id="E"
                        name="meioEnvio"
                        value="E"
                        checked={meioEnvio === 'E'}
                        onChange={handleMeioEnvio}
                        disabled={!podeAlterar}
                        {...formMethods}
                      />
                      <div className="subtitulo-p">
                        {t('principal.forms.labels.email_option')}
                      </div>
                    </label>

                    <label className="radio">
                      <Input
                        type="radio"
                        id="C"
                        name="meioEnvio"
                        value="C"
                        checked={meioEnvio === 'C'}
                        onChange={handleMeioEnvio}
                        //disabled="true"
                        //disabled={!podeAlterar}
                        {...formMethods}
                      />
                      <div className="subtitulo-p">
                        {t('principal.forms.labels.phone_option')}
                      </div>
                    </label>
                  </div>
                ) : (
                  <label>
                    {t('cadastro.messages.info.token_email_registration')}
                  </label>
                )}
              </div>
              <br />
              <br />
              <div className="dialog-footer">
                <button className="btn-txt btn-fecha-dialog" onClick={fechar}>
                  {t('principal.forms.buttons.cancel')}
                </button>
                <button
                  className="btn-pre"
                  id="btn-dados"
                  type="submit"
                  disabled={!podeAlterar}
                >
                  {t('principal.forms.buttons.change')}
                </button>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <form>
          <div id="finaliza-cadastro" className="conteudo">
            <div id="bem-vindo" className="card bg-superficie elev5">
              <img
                alt="Imagem de perfil da Carol"
                id="img-carol-boasvindas"
                src="/images/carol-perfil.png"
              />

              <h2>{t('principal.forms.titles.finalize_change')}</h2>

              <p className="txt-finalizacao">
                {t('principal.edit_data.finalize_message')}
              </p>
              <div className="campo-txt">
                <InputToken />
              </div>
              <div className="btns-row">
                <button
                  id="btn-reenviar"
                  type="button"
                  className="btn-cont"
                  onClick={reenviaToken}
                >
                  {t('principal.forms.buttons.resend_code')}
                </button>

                <button
                  id="btn-finalizar"
                  type="button"
                  className="btn-pre"
                  onClick={alterar}
                >
                  {t('principal.forms.buttons.finalize')}
                </button>
                <button
                  className="btn-txt btn-fecha-dialog"
                  onClick={fecharToken}
                >
                  {t('principal.forms.buttons.cancel')}
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  );
}
export default FormAlterarDadosEstrangeiro;
